$(function () {
    $('#SignUp #new_gym_user input[name="agreement"]').change(function() {
        monitoringAgreement();
    });
    $('#SignUp .radio-area button').click(function() {
        if ($(this).is(':checked')) {
            $('#SignUp #new_gym_user input[type="submit"]').prop('disabled', false);
        } else {
            $('#SignUp #new_gym_user input[type="submit"]').prop('disabled', true);
        }
    });
    $('body').on('click', '#SignUp .radio-area .radio', function() {
        const dataValue = $(this).data('value');
        $('#SignUp .radio-area .radio').removeClass('active')
        $(this).addClass('active')
        $('#SignUp #new_gym_user #gym_user_sex').val(dataValue);
    });

    monitoringAgreement();

    const sexValue = $('#SignUp #new_gym_user #gym_user_sex').val();
    $(`#SignUp .radio-area .radio[data-value="${sexValue}"]`).addClass('active')

});

// 同意ボタンのチェック有無で送信ボタンを有効にする
function monitoringAgreement () {
    if ($('#SignUp #new_gym_user input[name="agreement"]').is(':checked')) {
        $('#SignUp #new_gym_user input[type="submit"]').prop('disabled', false);
    } else {
        $('#SignUp #new_gym_user input[type="submit"]').prop('disabled', true);
    }
}
